import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <svg className="logo-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              Humanizador
            </div>
            <p className="footer-description">
              Transforme conteúdo gerado por IA em escrita natural e autêntica com qualidade profissional.
            </p>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">Nossos Produtos</h3>
            <ul className="footer-links">
              <li><a href="https://www.wingsgroup.ai/" target="_blank" rel="noopener noreferrer">Wings Group AI</a></li>
              <li><a href="https://iapm.astronmembers.com/" target="_blank" rel="noopener noreferrer">Curso IAPM</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">Contato</h3>
            <ul className="footer-links">
              <li><a href="mailto:contato@wingsgroup.ai">contato@wingsgroup.ai</a></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="copyright">
            © 2025 Humanizador by <a href="https://www.wingsgroup.ai/" target="_blank" rel="noopener noreferrer">Wings Group</a>. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;